import produce from "immer";
import { commonActions } from ".";
import { IStoreState } from "../initialStoreState";
import { defaultCommonState } from "./common.types";
import {
  CLEAR_GENERAL_HISTORY_STATE,
  CLEAR_RECORD_COUNTS,
  CLEAR_WHATSAPP_COUNTS,
  FETCH_GENERAL_HISTORY_LIST_FAILED,
  FETCH_GENERAL_HISTORY_LIST_PROGRESS,
  FETCH_GENERAL_HISTORY_LIST_SUCCESS,
  FETCH_MODULES_LIST_FAILED,
  FETCH_MODULES_LIST_PROGRESS,
  FETCH_MODULES_LIST_SUCCESS,
  FETCH_POLCIES_FAILED,
  FETCH_POLICIES_PROGRESS,
  FETCH_POLICIES_SUCCESS,
  FETCH_RECORD_COUNTS_FAILED,
  FETCH_RECORD_COUNTS_PROGRESS,
  FETCH_RECORD_COUNTS_SUCCESS,
  FETCH_WHATSAPP_COUNTS_FAILED,
  FETCH_WHATSAPP_COUNTS_PROGRESS,
  FETCH_WHATSAPP_COUNTS_SUCCESS,
  FETCH_PAYMENT_TRANSACTION_STATUS_PROGRESS,
  FETCH_PAYMENT_TRANSACTION_STATUS_SUCCESS,
  FETCH_PAYMENT_TRANSACTION_STATUS_FAILED,
  FETCH_ENDPOINTS_LIST_FAILED,
  FETCH_ENDPOINTS_LIST_PROGRESS,
  FETCH_ENDPOINTS_LIST_SUCCESS,
  CLEAR_PAYMENT_TRANSACTION_STATUS,
} from "./commonActions";
import { LoadState } from "../../constants/enums";

export const commonReducer = (
  state: IStoreState["common"] = defaultCommonState,
  action: commonActions
) => {
  switch (action.type) {
    case FETCH_POLICIES_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.policies.loadState = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_POLICIES_SUCCESS: {
      const { policies } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.policies.loadState = LoadState.Loaded;
        draftState.policies.list = policies;
      });
      return newState;
    }
    case FETCH_POLCIES_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.policies.loadState = LoadState.Failed;
        draftState.policies.list = [];
      });
      return newState;
    }

    case FETCH_GENERAL_HISTORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.InProgress;
        draftState.generalHistory.data = null;
        draftState.generalHistory.list = [];
      });
      return newState;
    }
    case FETCH_GENERAL_HISTORY_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.Loaded;
        draftState.generalHistory.data = data;
        draftState.generalHistory.list = data?.result || [];
      });
      return newState;
    }
    case FETCH_GENERAL_HISTORY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.Failed;
        draftState.generalHistory.data = null;
        draftState.generalHistory.list = [];
      });
      return newState;
    }
    case CLEAR_GENERAL_HISTORY_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory = defaultCommonState["generalHistory"];
      });
      return newState;
    }

    case FETCH_RECORD_COUNTS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.InProgress;
        draftState.generalHistory.list = [];
      });
      return newState;
    }
    case FETCH_RECORD_COUNTS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Loaded;
        draftState.recordCounts.list = data;
      });
      return newState;
    }
    case FETCH_RECORD_COUNTS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Failed;
        draftState.recordCounts.list = [];
      });
      return newState;
    }

    case CLEAR_RECORD_COUNTS: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts = defaultCommonState["recordCounts"];
      });
      return newState;
    }
    case FETCH_WHATSAPP_COUNTS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.whatsappCounts.loading = LoadState.InProgress;
        draftState.whatsappCounts.list = [];
      });
      return newState;
    }
    case FETCH_WHATSAPP_COUNTS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.whatsappCounts.loading = LoadState.Loaded;
        draftState.whatsappCounts.list = data;
      });
      return newState;
    }
    case FETCH_WHATSAPP_COUNTS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.whatsappCounts.loading = LoadState.Failed;
        draftState.whatsappCounts.list = [];
      });
      return newState;
    }
    case CLEAR_WHATSAPP_COUNTS: {
      const newState = produce(state, (draftState) => {
        draftState.whatsappCounts = defaultCommonState["whatsappCounts"];
      });
      return newState;
    }
    case FETCH_MODULES_LIST_PROGRESS: {
      const { isView } = action.payload;
      const newState = produce(state, (draftState) => {
        if (isView) {
          draftState.modules.tableViews = {
            data: [],
            loading: LoadState.InProgress,
          };
        } else {
          draftState.modules.tableNames = {
            data: [],
            loading: LoadState.InProgress,
          };
        }
      });
      return newState;
    }
    case FETCH_MODULES_LIST_SUCCESS: {
      const { isView, data } = action.payload;
      const newState = produce(state, (draftState) => {
        if (isView) {
          draftState.modules.tableViews = {
            data: data,
            loading: LoadState.Loaded,
          };
        } else {
          draftState.modules.tableNames = {
            data: data,
            loading: LoadState.Loaded,
          };
        }
      });
      return newState;
    }
    case FETCH_MODULES_LIST_FAILED: {
      const { isView } = action.payload;
      const newState = produce(state, (draftState) => {
        if (isView) {
          draftState.modules.tableViews = {
            data: [],
            loading: LoadState.Failed,
          };
        } else {
          draftState.modules.tableNames = {
            data: [],
            loading: LoadState.Failed,
          };
        }
      });
      return newState;
    }

    case FETCH_PAYMENT_TRANSACTION_STATUS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.paymentTransactionCounts.loading = LoadState.InProgress;
        draftState.paymentTransactionCounts.list = [];
      });
      return newState;
    }
    case FETCH_PAYMENT_TRANSACTION_STATUS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.paymentTransactionCounts.loading = LoadState.Loaded;
        draftState.paymentTransactionCounts.list = data;
      });
      return newState;
    }
    case FETCH_PAYMENT_TRANSACTION_STATUS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.paymentTransactionCounts.loading = LoadState.Failed;
        draftState.paymentTransactionCounts.list = [];
      });
      return newState;
    }

    case FETCH_ENDPOINTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.endPointsByModule.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_ENDPOINTS_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.endPointsByModule.loading = LoadState.Loaded;
        draftState.endPointsByModule.data = data;
      });
      return newState;
    }
    case FETCH_ENDPOINTS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.endPointsByModule.loading = LoadState.Failed;
        draftState.endPointsByModule.data = {};
      });
      return newState;
    }
    case CLEAR_PAYMENT_TRANSACTION_STATUS: {
      const newState = produce(state, (draftState) => {
        draftState.paymentTransactionCounts =
          defaultCommonState["paymentTransactionCounts"];
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
